import { defineComponent as _defineComponent } from 'vue'
import {PropType} from "vue";
  import EmployeeDetailsCardListEntry from "./EmployeeDetailsCardListEntry.vue";
  import EmployeeDetailsCard from "./EmployeeDetailsCard.vue";
  import Employee from "@/model/Employee";
  import {t} from "@/mixin/mixins";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'EmployeeDetailsCardExport',
  props: {
    editable: {
      type: Boolean,
      default: () => false
    },
    employee: {
      type: Object as PropType<Employee>,
      default: () => new Employee()
    }
  },
  setup(__props) {

const props = __props

  

return { __sfc: true,props, EmployeeDetailsCardListEntry, EmployeeDetailsCard, t }
}

})